import React from 'react';
import { TableDataCase } from '../TableDataCase';
import { Divider } from '../../../../atoms/Dividers/Divider';
import { ElevesDashboard } from '../../../../../types/classe/maClasse';

export interface TableDataLineChallengeProps {
  eleve: ElevesDashboard;
}

export const TableDataLineChallenge = ({
  eleve
}: TableDataLineChallengeProps) => {
  const note = eleve.note;
  if (!note) return null;

  return (
    <>
      <tr>
        <TableDataCase
          variant={'data'}
          data={`${eleve?.lastname} ${eleve?.firstname}`}
        />
        <TableDataCase variant={'note'} data={note.moyennegenerale} />
        <TableDataCase variant={'note'} data={note.cavente} />
        <TableDataCase variant={'note'} data={note.nbvente} />
        <TableDataCase variant={'note'} data={note.pro} />
        <TableDataCase variant={'note'} data={note.venterebond} />
        <TableDataCase variant={'note'} data={note.quiz} />
      </tr>
      <Divider color={'light'} margin={false} />
    </>
  );
};
